import React, { useState, useEffect } from "react";
import Modal from "@material-ui/core/Modal";
import "./MenuDimensionsModal.css";
import "./MenuDimensionsModalAddlStyles.css";
import Button from "@material-ui/core/Button";

function MenuDimensionsModal({
  open,
  close,
  isNew,
  menuWidth,
  chapterThumbHeight,
  pageThumbHeight,
  chapterTextFontSize,
  chapterTextMaxWidth,
  hideGradient,
  applyChanges,
}) {
  const [tempMenuWidth, setTempMenuWidth] = useState(menuWidth);
  const [tempChapterThumbHeight, setTempChapterThumbHeight] = useState(chapterThumbHeight);
  const [tempPageThumbHeight, setTempPageThumbHeight] = useState(pageThumbHeight);
  const [tempPageTextMaxWidth, setTempChapterTextMaxWidth] = useState(chapterTextMaxWidth);
  const [tempPageTextFontSize, setTempChapterTextFontSize] = useState(chapterTextFontSize);
  const [tempHideGradient, setTempHideGradient] = useState(hideGradient);

  const [tempChapterText, setTempChapterText] = useState("");

  useEffect(() => {
    setTempMenuWidth(menuWidth);
    setTempChapterThumbHeight(chapterThumbHeight);
    setTempPageThumbHeight(pageThumbHeight);
    setTempChapterTextMaxWidth(chapterTextMaxWidth);
    setTempChapterTextFontSize(chapterTextFontSize);
  }, [menuWidth, chapterThumbHeight, pageThumbHeight, chapterTextMaxWidth, chapterTextFontSize]);

  useEffect(() => {
    limitPageThumbHeight();
  }, [tempChapterThumbHeight]);

  useEffect(() => {
    adjustChapterThumbHeight();
  }, [tempPageThumbHeight]);

  function adjustChapterThumbHeight() {
    if (tempPageThumbHeight > tempChapterThumbHeight) setTempChapterThumbHeight(tempPageThumbHeight);
  }

  function limitPageThumbHeight() {
    if (tempPageThumbHeight > tempChapterThumbHeight) setTempPageThumbHeight(Math.min(90, tempChapterThumbHeight));
  }

  function applyAndClose() {
    applyChanges(
      tempMenuWidth,
      tempChapterThumbHeight,
      tempPageThumbHeight,
      tempPageTextMaxWidth,
      tempPageTextFontSize,
      tempHideGradient
    );
    close();
  }

  function cancel() {
    setTempMenuWidth(menuWidth);
    setTempChapterThumbHeight(chapterThumbHeight);
    setTempPageThumbHeight(pageThumbHeight);
    setTempChapterTextMaxWidth(chapterTextMaxWidth);
    setTempChapterTextFontSize(chapterTextFontSize);
    setTempHideGradient(hideGradient);
    close();
  }

  return (
    <Modal open={open} onClose={cancel} className="page-modal">
      <div style={{ position: "relative" }}>
        {isNew && (
          <div
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              backgroundColor: "#ffffffaa",
              zIndex: 9999,
              display: "flex",
              alignItems: "center",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                gap: "1rem",
                maxWidth: "50%",
                margin: "0 auto",
                padding: "1rem",
                borderRadius: "0.5rem",
                backgroundColor: "#fff",
                boxShadow: "0 5px 5px 0 #00000040",
                textAlign: "center",
              }}
            >
              <p>
                These settings will not work until you finalize the creation of this book, then author and save a page.
              </p>
              <Button color="primary" variant="contained" onClick={close}>
                OK
              </Button>
            </div>
          </div>
        )}
        <div
          style={{
            width: "fit-content",
            background: "white",
            height: "90vh",
            padding: "20px",
            display: "flex",
            alignItems: "flex-start",
            gap: "1rem",
          }}
        >
          <div
            style={{
              height: "100%",
              overflow: "auto",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              margin: "1rem 0",
              paddingBottom: "1rem",
            }}
          >
            <p style={{ fontSize: "1.5rem", fontWeight: 600 }}>Menu dimension options</p>
            <p style={{ marginBottom: "0.5rem" }}>Menu width:</p>
            <div
              style={{
                width: "fit-content",
                display: "flex",
                alignItems: "center",
                marginBottom: "2rem",
              }}
            >
              <input
                type="range"
                style={{ margin: "0 0.5rem" }}
                min={150}
                max={300}
                value={tempMenuWidth}
                onChange={(e) => setTempMenuWidth(Number(e.target.value))}
              />
              <div>
                <div>
                  <input
                    type="number"
                    min={150}
                    max={300}
                    value={tempMenuWidth}
                    onChange={(e) => setTempMenuWidth(Number(e.target.value))}
                  />
                  <span style={{ marginLeft: "0.25rem" }}>px</span>
                </div>
                <span style={{ fontSize: "0.7rem" }}>Default: 300</span>
              </div>
            </div>
            <p style={{ marginBottom: "0.5rem" }}>Chapter thumbnail height:</p>
            <div
              style={{
                width: "fit-content",
                display: "flex",
                alignItems: "center",
                marginBottom: "2rem",
              }}
            >
              <input
                type="range"
                style={{ margin: "0 0.5rem" }}
                min={70}
                max={180}
                value={tempChapterThumbHeight}
                onChange={(e) => setTempChapterThumbHeight(Number(e.target.value))}
              />
              <div>
                <div>
                  <input
                    type="number"
                    min={70}
                    max={180}
                    value={tempChapterThumbHeight}
                    onChange={(e) => setTempChapterThumbHeight(Number(e.target.value))}
                  />
                  <span style={{ marginLeft: "0.25rem" }}>px</span>
                </div>
                <span style={{ fontSize: "0.7rem" }}>Default: 90</span>
              </div>
            </div>
            <p style={{ marginBottom: "0.5rem" }}>Page thumbnail height:</p>
            <div
              style={{
                width: "fit-content",
                display: "flex",
                alignItems: "center",
              }}
            >
              <input
                type="range"
                style={{ margin: "0 0.5rem" }}
                min={50}
                max={140}
                value={tempPageThumbHeight}
                onChange={(e) => setTempPageThumbHeight(Number(e.target.value))}
              />
              <div>
                <div>
                  <input
                    type="number"
                    min={50}
                    max={140}
                    value={tempPageThumbHeight}
                    onChange={(e) => setTempPageThumbHeight(Number(e.target.value))}
                  />
                  <span style={{ marginLeft: "0.25rem" }}>px</span>
                </div>
                <span style={{ fontSize: "0.7rem" }}>Default: 70</span>
              </div>
            </div>
            <p
              style={{
                fontSize: "0.8rem",
                color: "gray",
                fontStyle: "italic",
                margin: "0.5rem 0 2rem 0",
              }}
            >
              Note: page height cannot exceed chapter height.
            </p>
            <hr style={{ width: "100%", border: 0, borderTop: "1px solid gray", margin: "1rem 0" }} />
            <p style={{ fontSize: "1.5rem", fontWeight: 600 }}>Chapter text options</p>
            <label style={{ margin: "1rem 0", fontSize: "0.8rem" }}>
              Placeholder text{" "}
              <input type="text" value={tempChapterText} onChange={(e) => setTempChapterText(e.target.value)} />
            </label>
            <p>Font size</p>
            <div
              style={{
                width: "fit-content",
                display: "flex",
                alignItems: "center",
              }}
            >
              <input
                type="range"
                style={{ margin: "0 0.5rem" }}
                min={5}
                max={30}
                step={0.1}
                value={tempPageTextFontSize}
                onChange={(e) => setTempChapterTextFontSize(Number(e.target.value))}
              />
              <div>
                <div>
                  <input
                    type="number"
                    min={5}
                    max={30}
                    value={tempPageTextFontSize}
                    onChange={(e) => setTempChapterTextFontSize(Number(e.target.value))}
                    style={{ width: "3.5rem" }}
                  />
                  <span style={{ marginLeft: "0.25rem" }}>px</span>
                </div>
                <span style={{ fontSize: "0.7rem" }}>Default: 22.4</span>
              </div>
            </div>
            <p>
              Chapter text max width
              <br />
              (relative to container)
            </p>
            <div
              style={{
                width: "fit-content",
                display: "flex",
                alignItems: "center",
              }}
            >
              <input
                type="range"
                style={{ margin: "0 0.5rem" }}
                min={10}
                max={100}
                value={tempPageTextMaxWidth}
                onChange={(e) => setTempChapterTextMaxWidth(Number(e.target.value))}
              />
              <div>
                <div>
                  <input
                    type="number"
                    min={10}
                    max={100}
                    value={tempPageTextMaxWidth}
                    onChange={(e) => setTempChapterTextMaxWidth(Number(e.target.value))}
                    style={{ width: "3.2rem" }}
                  />
                  <span style={{ marginLeft: "0.25rem" }}>%</span>
                </div>
                <span style={{ fontSize: "0.7rem" }}>Default: 100</span>
              </div>
            </div>
            <hr style={{ width: "100%", border: 0, borderTop: "1px solid gray", margin: "1rem 0" }} />
            <p style={{ fontSize: "1.5rem", fontWeight: 600 }}>Miscellaneous options</p>
            <label>
              <input
                type="checkbox"
                style={{ marginRight: "0.25rem" }}
                checked={tempHideGradient}
                onChange={(e) => setTempHideGradient(e.target.checked)}
              />
              Hide gradient
            </label>
            <hr style={{ width: "100%", border: 0, borderTop: "1px solid gray", margin: "1rem 0" }} />
            <div style={{ display: "flex", gap: "0.5rem", marginTop: "1rem" }}>
              <Button color="primary" variant="contained" onClick={applyAndClose}>
                Apply
              </Button>
              <Button color="secondary" variant="contained" onClick={cancel}>
                Cancel
              </Button>
            </div>
          </div>

          {/* PREVIEW */}
          <div
            style={{
              minWidth: "300px",
              height: "100%",
              paddingLeft: "1rem",
              borderLeft: "1px solid darkGray",
              boxSizing: "content-box",
            }}
          >
            <div
              style={{
                height: "100%",
                display: "flex",
                flexDirection: "column",
                flexGrow: 1,
                alignItems: "center",
                overflow: "auto",
                backgroundColor: "#141414",
              }}
            >
              <div style={{ display: "flex", justifyContent: "center", backgroundColor: "#fff", width: "100%" }}>
                <p
                  style={{
                    fontSize: "0.8rem",
                    color: "gray",
                    fontStyle: "italic",
                    margin: 0,
                    paddingBottom: "0.5rem",
                  }}
                >
                  Thumbnails are only a sample
                  <br />
                  and don't reflect current data.
                </p>
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  flexGrow: 1,
                  backgroundColor: "black",
                  alignSelf: "flex-start",
                }}
              >
                <div className="reader-menu" style={{ width: `${tempMenuWidth}px` }}>
                  <div className="reader-menu__title">Menu</div>
                  <div className="reader-menu__contents">
                    <div className="reader-menu__chapters">
                      <div>
                        <div className="reader-menu__option-title current">
                          <div
                            style={{
                              position: "absolute",
                              top: "0px",
                              left: "0px",
                              width: "100%",
                              height: "100%",
                              display: "flex",
                              alignItems: "center",
                              background: "linear-gradient(90deg, rgba(0, 0, 0, 0.867) 30%, transparent 80%)",
                            }}
                          >
                            <div className="menu-option__arrow">
                              <svg
                                stroke="currentColor"
                                fill="currentColor"
                                strokeWidth="0"
                                viewBox="0 0 1024 1024"
                                height="1em"
                                width="1em"
                                xmlns="http://www.w3.org/2000/svg"
                                style={{ transform: "rotate(90deg)", transition: "transform 150ms ease 0s" }}
                              >
                                <path d="M715.8 493.5L335 165.1c-14.2-12.2-35-1.2-35 18.5v656.8c0 19.7 20.8 30.7 35 18.5l380.8-328.4c10.9-9.4 10.9-27.6 0-37z"></path>
                              </svg>
                            </div>
                            <span>Chapters</span>
                          </div>
                        </div>
                        <div className="drop-down-content">
                          <div>
                            <div
                              className="reader-menu__option-title chapter current"
                              style={{
                                height: `${tempChapterThumbHeight}px`,
                                backgroundImage:
                                  'url("https://d24hdgytax3x03.cloudfront.net/138/thumbnails/-1/chapter")',
                                backgroundSize: "100%",
                              }}
                            >
                              <div
                                style={{
                                  position: "absolute",
                                  top: "0px",
                                  left: "0px",
                                  width: "100%",
                                  height: "100%",
                                  display: "flex",
                                  alignItems: "center",
                                  background: "linear-gradient(90deg, rgba(0, 0, 0, 0.867) 30%, transparent 80%)",
                                }}
                              >
                                <div className="menu-option__arrow">
                                  <svg
                                    stroke="currentColor"
                                    fill="currentColor"
                                    strokeWidth="0"
                                    viewBox="0 0 1024 1024"
                                    height="1em"
                                    width="1em"
                                    xmlns="http://www.w3.org/2000/svg"
                                    style={{ transition: "transform 150ms ease 0s", transform: "rotate(90deg)" }}
                                  >
                                    <path d="M715.8 493.5L335 165.1c-14.2-12.2-35-1.2-35 18.5v656.8c0 19.7 20.8 30.7 35 18.5l380.8-328.4c10.9-9.4 10.9-27.6 0-37z"></path>
                                  </svg>
                                </div>
                                <span
                                  style={{
                                    maxWidth: `${tempPageTextMaxWidth}%`,
                                    fontSize: `${tempPageTextFontSize}px`,
                                    lineHeight: `${tempPageTextFontSize}px`,
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                  }}
                                >
                                  {tempChapterText.length > 0 ? tempChapterText : "Movement 1"}
                                </span>
                              </div>
                            </div>
                            <div className="drop-down-content">
                              <div style={{ color: "white", display: "flex", flexDirection: "column" }}>
                                <ul style={{ margin: "0px" }}>
                                  <li
                                    className="reader-menu__page-option current"
                                    style={{
                                      backgroundImage:
                                        'url("https://d9fedpdsh4r16.cloudfront.net/misc/sample-thumb.webp")',
                                      backgroundPosition: "center",
                                      backgroundSize: "100%",
                                      height: `${tempPageThumbHeight}px`,
                                    }}
                                  >
                                    <div
                                      className="page-button-fade-wrapper"
                                      style={{
                                        background: tempHideGradient
                                          ? null
                                          : "linear-gradient(90deg, #000000dd 20%, transparent 70%)",
                                      }}
                                    >
                                      <span>1</span>
                                    </div>
                                  </li>
                                  <li
                                    className="reader-menu__page-option "
                                    style={{
                                      backgroundImage:
                                        'url("https://d9fedpdsh4r16.cloudfront.net/misc/sample-thumb.webp")',
                                      backgroundPosition: "center",
                                      backgroundSize: "100%",
                                      height: `${tempPageThumbHeight}px`,
                                    }}
                                  >
                                    <div
                                      className="page-button-fade-wrapper"
                                      style={{
                                        background: tempHideGradient
                                          ? null
                                          : "linear-gradient(90deg, #000000dd 20%, transparent 70%)",
                                      }}
                                    >
                                      <span>2</span>
                                    </div>
                                  </li>
                                  <li
                                    className="reader-menu__page-option "
                                    style={{
                                      backgroundImage:
                                        'url("https://d9fedpdsh4r16.cloudfront.net/misc/sample-thumb.webp")',
                                      backgroundPosition: "center",
                                      backgroundSize: "100%",
                                      height: `${tempPageThumbHeight}px`,
                                    }}
                                  >
                                    <div
                                      className="page-button-fade-wrapper"
                                      style={{
                                        background: tempHideGradient
                                          ? null
                                          : "linear-gradient(90deg, #000000dd 20%, transparent 70%)",
                                      }}
                                    >
                                      <span>3</span>
                                    </div>
                                  </li>
                                </ul>
                              </div>
                            </div>
                          </div>
                          <div>
                            <div
                              className="reader-menu__option-title chapter"
                              style={{
                                height: `${tempChapterThumbHeight}px`,
                                backgroundImage:
                                  'url("https://d24hdgytax3x03.cloudfront.net/138/thumbnails/0/chapter")',
                                backgroundSize: "100%",
                              }}
                            >
                              <div
                                style={{
                                  position: "absolute",
                                  top: "0px",
                                  left: "0px",
                                  width: "100%",
                                  height: "100%",
                                  display: "flex",
                                  alignItems: "center",
                                  background: "linear-gradient(90deg, rgba(0, 0, 0, 0.867) 30%, transparent 80%)",
                                }}
                              >
                                <div className="menu-option__arrow">
                                  <svg
                                    stroke="currentColor"
                                    fill="currentColor"
                                    strokeWidth="0"
                                    viewBox="0 0 1024 1024"
                                    height="1em"
                                    width="1em"
                                    xmlns="http://www.w3.org/2000/svg"
                                    style={{ transition: "transform 150ms ease 0s", transform: "rotate(90deg)" }}
                                  >
                                    <path d="M715.8 493.5L335 165.1c-14.2-12.2-35-1.2-35 18.5v656.8c0 19.7 20.8 30.7 35 18.5l380.8-328.4c10.9-9.4 10.9-27.6 0-37z"></path>
                                  </svg>
                                </div>
                                <span
                                  style={{
                                    maxWidth: `${tempPageTextMaxWidth}%`,
                                    fontSize: `${tempPageTextFontSize}px`,
                                    lineHeight: `${tempPageTextFontSize}px`,
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                  }}
                                >
                                  {tempChapterText.length > 0 ? tempChapterText : "Movement 2"}
                                </span>
                              </div>
                            </div>
                            <div className="drop-down-content">
                              <div style={{ color: "white", display: "flex", flexDirection: "column" }}>
                                <ul style={{ margin: "0px" }}>
                                  <li
                                    className="reader-menu__page-option "
                                    style={{
                                      backgroundImage:
                                        'url("https://d9fedpdsh4r16.cloudfront.net/misc/sample-thumb.webp")',
                                      backgroundPosition: "center",
                                      backgroundSize: "100%",
                                      height: `${tempPageThumbHeight}px`,
                                    }}
                                  >
                                    <div
                                      className="page-button-fade-wrapper"
                                      style={{
                                        background: tempHideGradient
                                          ? null
                                          : "linear-gradient(90deg, #000000dd 20%, transparent 70%)",
                                      }}
                                    >
                                      <span>1</span>
                                    </div>
                                  </li>
                                  <li
                                    className="reader-menu__page-option "
                                    style={{
                                      backgroundImage:
                                        'url("https://d9fedpdsh4r16.cloudfront.net/misc/sample-thumb.webp")',
                                      backgroundPosition: "center",
                                      backgroundSize: "100%",
                                      height: `${tempPageThumbHeight}px`,
                                    }}
                                  >
                                    <div
                                      className="page-button-fade-wrapper"
                                      style={{
                                        background: tempHideGradient
                                          ? null
                                          : "linear-gradient(90deg, #000000dd 20%, transparent 70%)",
                                      }}
                                    >
                                      <span>2</span>
                                    </div>
                                  </li>
                                  <li
                                    className="reader-menu__page-option "
                                    style={{
                                      backgroundImage:
                                        'url("https://d9fedpdsh4r16.cloudfront.net/misc/sample-thumb.webp")',
                                      backgroundPosition: "center",
                                      backgroundSize: "100%",
                                      height: `${tempPageThumbHeight}px`,
                                    }}
                                  >
                                    <div
                                      className="page-button-fade-wrapper"
                                      style={{
                                        background: tempHideGradient
                                          ? null
                                          : "linear-gradient(90deg, #000000dd 20%, transparent 70%)",
                                      }}
                                    >
                                      <span>3</span>
                                    </div>
                                  </li>
                                </ul>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="reader-menu__tips">
                      <div>
                        <div className="reader-menu__option-title current">
                          <div
                            style={{
                              position: "absolute",
                              top: "0px",
                              left: "0px",
                              width: "100%",
                              height: "100%",
                              display: "flex",
                              alignItems: "center",
                              background: "linear-gradient(90deg, rgba(0, 0, 0, 0.867) 30%, transparent 80%)",
                            }}
                          >
                            <div className="menu-option__arrow">
                              <svg
                                stroke="currentColor"
                                fill="currentColor"
                                strokeWidth="0"
                                viewBox="0 0 1024 1024"
                                height="1em"
                                width="1em"
                                xmlns="http://www.w3.org/2000/svg"
                                style={{ transition: "transform 150ms ease 0s" }}
                              >
                                <path d="M715.8 493.5L335 165.1c-14.2-12.2-35-1.2-35 18.5v656.8c0 19.7 20.8 30.7 35 18.5l380.8-328.4c10.9-9.4 10.9-27.6 0-37z"></path>
                              </svg>
                            </div>
                            <span>Artist tips (Movement 1)</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
}

export default MenuDimensionsModal;
